/** @format */

import jwt_decode from 'jwt-decode';
import { getTelecmiSoftphoneToken } from './telecmiSoftphoneSession';

export function getRequireTelecmiLoginFromJwt() {
  try {
    const t = localStorage.getItem('token');
    if (!t) return false;
    const d = jwt_decode(t);
    return d?.require_telecmi_login === true;
  } catch {
    return false;
  }
}

/**
 * Build body for POST /api/telecmi/initiate: token flow vs legacy secret/user_id flow.
 * @param {number} toNum - destination E.164-style number
 * @param {Record<string, unknown>} extraParams - e.g. { crm: true, bulk_call: true }
 * @returns {{ payload: object } | { error: string }}
 */
export function buildTelecmiInitiatePayload(toNum, extraParams = { crm: true }) {
  if (getRequireTelecmiLoginFromJwt()) {
    const token = getTelecmiSoftphoneToken();
    if (!token) {
      return {
        error:
          'Sign in to TeleCMI softphone (header) before placing a call.',
      };
    }
    return {
      payload: {
        to: toNum,
        user_token: token,
        extra_params: extraParams,
      },
    };
  }
  return {
    payload: {
      to: toNum,
      webrtc: false,
      followme: true,
      extra_params: extraParams,
    },
  };
}
